import { CurrentUser } from '../../../../../global'

export const registryProperties = (currentUser: CurrentUser | undefined) => ({
  registryId: currentUser?.currentRegistry.id,
  registryOwnerId: currentUser?.currentRegistry.ownerId,
  listType: currentUser?.currentRegistry.type || 'baby_registry',
  isRegistryOwner: currentUser?.currentRegistry.currentUserRole === 'owner',
})
